import Script from 'next/script'
import { gtagConfig } from './config'

const GtagScript = () => {
  // If we have a measurement ID, load the real gtag script
  if (gtagConfig.measurementId) {
    return (
      <>
        {/* Google tag (gtag.js) */}
        <Script
          id='gtag-script'
          strategy='afterInteractive'
          src={`https://www.googletagmanager.com/gtag/js?id=${gtagConfig.measurementId}`}
        />
        <Script
          id='gtag-config'
          strategy='afterInteractive'
          dangerouslySetInnerHTML={{
            __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${gtagConfig.measurementId}', {
                transport_type: 'beacon',
                send_page_view: false
              });
            `
          }}
        />
      </>
    )
  }

  // If we're in debug mode but don't have a measurement ID, create a mock gtag function
  if (gtagConfig.debugMode && !gtagConfig.measurementId) {
    return (
      <Script
        id='gtag-mock'
        strategy='afterInteractive'
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            // Mock gtag initialized for debug mode
          `
        }}
      />
    )
  }

  return null
}

export default GtagScript
